/**
 * Modes of the shared search surface. Each host owns the keyword result target;
 * AI mode always drives its RAG chat.
 */
export const SEARCH_MODES = {
  KEYWORD: 'keyword',
  AI: 'ai',
};
